export default __webpack_public_path__ + "static/media/risk.4aa43298.svg";